// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.css'
import VueCordova from 'vue-cordova'
import VueHead from 'vue-head'
import Vue2TouchEvents from 'vue2-touch-events'
import axios from 'axios'
import 'isomorphic-fetch'

import App from './App'
import router from './router'
import auth from './services/authService'
import configurationService from './services/configurationService'
import connectivityTrackingService from './services/connectivityTrackingService'
import { log } from '@/services/logService.js'

Vue.config.productionTip = false
Vue.use(Vuetify, {
  theme: {
    primary: '#2181c4'
  }
})
Vue.use(VueCordova)
Vue.use(VueHead)
Vue.use(Vue2TouchEvents)

// add cordova.js only if serving the app through file://
if (window.location.protocol === 'file:' || window.location.port === '3000') {
  var cordovaScript = document.createElement('script')
  cordovaScript.setAttribute('type', 'text/javascript')
  cordovaScript.setAttribute('src', 'cordova.js')
  document.body.appendChild(cordovaScript)
  Vue.prototype.$mobileapp = true
} else {
  // import('./services/firebaseMessagingService.js')
  Vue.prototype.$mobileapp = false
}

router.beforeEach(async (to, from, next) => {
  if (Vue.prototype.$mobileapp && configurationService.getConfiguration().android.forceUpdate && to.path !== '/mobile-application') {
    next({
      path: '/mobile-application'
    })
  } else if (to.matched.some(record => record.meta.allowAdmin) && !(await auth.isAdmin())) {
    // console.log('redirect non-admin to home')
    next({
      path: '/'
    })
  } else if (to.matched.some(record => !record.meta.allowAnonymous) && !auth.isAuthenticated()) {
    // console.log('redirect non-authenticated to login', to.matched)
    next({
      path: '/login',
      query: {
        redirect: to.fullPath
      }
    })
  } else if (to.matched.some(record => !record.meta.allowAuthenticated) && auth.isAuthenticated()) {
    // console.log('redirect authenticated to home')
    next({
      path: '/'
    })
  } else {
    next()
  }
})

// attach Authorization header to HTTP requests.
axios.interceptors.request.use(async (config) => {
  if (config.headers.Auth) {
    delete config.headers.Auth
    return config
  }
  try {
    const session = await auth.getCurrentSessionPromise()
    config.headers.Authorization = session.idToken.jwtToken
    connectivityTrackingService.start()
    return config
  } catch (e) {
    if (router.match(location).fullPath.indexOf('redirect') === -1) {
      // console.log('redirecting to login after erroneous axios request ', config)
      router.push('/login?redirect=' + router.match(location).fullPath)
    }
    return Promise.reject(new Error('Not authenticated'))
  }
}, (error) => {
  log(`Axios request error`, error)
  return Promise.reject(error)
})

axios.interceptors.response.use(function (response) {
  connectivityTrackingService.success()
  return response
}, function (error) {
  if (!error.response) {
    // network error
    log('network error')
    connectivityTrackingService.fail()
  } else {
    log(`Axios response error ${JSON.stringify(error)}`, error)
    // not a network error, so from connectivity perspective this is success
    connectivityTrackingService.success()
  }
  return Promise.reject(error)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  head: {
    meta: [
      {
        name: 'viewport',
        content: 'width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover'
      }
    ]
  }
})
